import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription, Subject } from 'rxjs';
import { Product2, Company } from 'situview-webapi-client';
import { ConfigService } from '../../services/config.service';
import { CompanyViewService } from '../../services';

export class SelectProductDialogData {
  companyId: string | undefined;
  classificationId: string | undefined;
  productTypeId: string | undefined;
  /** Specification IDs to pre-tick on open (e.g. role seeds for a planting area). */
  seedSpecificationIds?: string[];
  /** When true the catalog list lets the user tick multiple products
   *  and the result returns them all. Default false (single-pick). */
  multiSelect?: boolean;
}

export interface SelectProductResultData {
  products: Product2[];
  companyId: string | undefined;
  classificationId: string | undefined;
  productTypeId: string | undefined;
}

@Component({
  selector: 'select-product-dialog',
  templateUrl: './select-product-dialog.component.html',
  styleUrls: ['./select-product-dialog.component.scss']
})
export class SelectProductDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  isDrawerOpen = false;
  allCompanies: Company[] = [];
  selectedProducts: Product2[] = [];
  companyId: string | undefined;
  classificationId: string | undefined;
  productTypeId: string | undefined;
  seedSpecificationIds: string[] = [];
  url: string | undefined;
  posterUrl: string | undefined;
  productWidth: number = 150;

  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectProductDialogData,
    private dialogRef: MatDialogRef<SelectProductDialogData>,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private configService: ConfigService,
    private companyViewService: CompanyViewService) {

    this.companyId = data.companyId;
    this.classificationId = data.classificationId;
    this.productTypeId = data.productTypeId;
    this.seedSpecificationIds = data.seedSpecificationIds ?? [];

    this.companyViewService.LoadCompanies().then((companies: Company[]) => {
      this.allCompanies = companies;
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.resizeModelViewer();
  }

  ngOnDestroy(): void {
  }

  private resizeModelViewer() {
    if (this.modelContainer) {
      const parentWidth = this.modelContainer.nativeElement.offsetWidth;

      // Set the model-viewer size
      this.productWidth = parentWidth * 0.9;
      this.cdr.detectChanges(); // Trigger change detection manually
    }
  }

  onFilterCompanyId(companyId: string) {
    this.companyId = companyId;
  }

  onFilterClassificationId(classificationId: string) {
    this.classificationId = classificationId;
  }

  onFilterProductTypeId(productTypeId: string) {
    this.productTypeId = productTypeId;
  }

  onProductSelected(products: Product2[]) {
    this.selectedProducts = products;
    var product = products[0];

    this.isDrawerOpen = true;

    if (product?.previewArtifactId) {
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactid=${product.previewArtifactId}&filename=product-web.glb`;
      this.posterUrl = `${this.configService.config.situViewWebApiBaseUrl}/home/getimage?artifactid=${product.previewArtifactId}&filename=preview.webp`;
    }
    else {
      this.url = undefined;
      this.posterUrl = undefined;
    }
  }

  getCompanyLogo(companyId: string) {
    return this.allCompanies.find(x => x.id === companyId)?.logoUrl;
  }

  getCompanyName(companyId: string) {
    return this.allCompanies.find(x => x.id === companyId)?.name;
  }

  onProductDetailsClose() {
    this.isDrawerOpen = false;
  }

  selectProduct() {
    if (this.selectedProducts.length > 0) {

      var result = {
        products: this.selectedProducts,
        companyId: this.companyId,
        classificationId: this.classificationId,
        productTypeId: this.productTypeId
      } as SelectProductResultData;

      this.dialogRef.close(result);
    }
    else {
      this.showMessage("No product selected");
    }
  }

  private showMessage(message: string) {
    this.snackBar.open(message, "OK", { duration: 2000 });
  }
}
